import React from 'react'
import { connect } from 'react-redux'
import { ProductBuilderState } from '../state'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/styles/makeStyles'
import { priceToString } from '../../../core'

const useStyles = makeStyles((theme: any) => ({
    root: {
        '& .PriceAndNextItem-container': {
            marginTop: theme.spacing(25)
        },
        '& .PriceAndNextItem': {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'row'
            }
        },
        '& .TotalItem': {
            marginBottom: theme.spacing(2)
        }
    }
}), { name: 'ProductBuilderNext' })

const productBuilderNextView = (props: ProductBuilderState) => {
    const classes = useStyles(props)
    const total = props.productCost.find(it => it.total)
    return <Grid container direction='column' className={classes.root}>
        <Grid item style={{ flexGrow: 1 }} container direction='column' justify='flex-start' alignItems='stretch' className='PriceAndNextItem-container'>
            <Grid item container direction='column' alignItems='center' className='PriceAndNextItem' wrap='nowrap'>
                <Grid item container direction='column' alignItems='center'>
                    <Typography variant='overline'>Price</Typography>
                    <Box className='TotalItem'>
                        {total && <Typography variant='h6'>{priceToString(total.amount, props.product.currency)}</Typography>}
                    </Box>
                </Grid>
                <Button
                    variant='contained'
                    fullWidth
                    color='primary'
                    onClick={() => props.dispatch({ type: 'PRODUCT_BUILDER_STEP_INDEX_CHANGE', params: props.stepIndex + 1 })} >
                    Next
                </Button>
            </Grid>
        </Grid>
        <Grid item container>
            <Grid item xs={3}>
                <Divider light />
                <Box>
                    <Typography variant='overline'>SKU</Typography>
                </Box>
                <Box>
                    <Typography variant='overline'>Categories</Typography>
                </Box>
            </Grid>
            <Grid item xs={9}>
                <Divider light />
                <Box>
                    <Typography variant='overline'>{props.product.sku}</Typography>
                </Box>
                <Box>
                    <Typography variant='overline'>{props.product.categories ? props.product.categories.join(', ') : ''}</Typography>
                </Box>
            </Grid>
        </Grid>
    </Grid>
}

export const ProductBuilderNextView =
    connect((state: any) => state.productBuilderState)(productBuilderNextView)